<template>
  <div class="function-wrapper" v-if="visible">
    <h4 class="text-primary pt-3">Descarga de Recibos de Pagos de Póliza</h4>
    <b-row class="py-5">
      <b-col sm="12">
        <p>
          <b class="text-primary">Póliza:</b>
          {{ nroPoliza }}
        </p>
      </b-col>
      <b-col sm="12">
        <p>
          <b class="text-primary">Asegurado:</b>
          {{ nombreAsegurado }}
        </p>
      </b-col>
    </b-row>
    <h6 class="text-primary mb-3">Seleccione el recibo a descargar</h6>
    <b-row class="py-3">
      <b-col>
        <p class="text-primary">
          <b>Fecha de Recibo:</b>
        </p>
      </b-col>
      <b-col>
        <b-form-select :options="[]" />
      </b-col>
    </b-row>
    <b-row class="pb-5">
      <b-col></b-col>
      <b-col class="text-right">
        <b-btn variant="primary">Descargar Recibo</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    nroPoliza: {
      type: Number | String
    },
    nombreAsegurado: {
      type: String
    },
    tomador: {
      type: Number | String
    },
    nroEndoso: {
      type: Number | String
    }
  },

  data() {
    return {
      visible: false,
    };
  },

  methods: {
    
  }
};
</script>
